import { render, staticRenderFns } from "./InversionsTable.vue?vue&type=template&id=a56c328c&scoped=true&"
import script from "./InversionsTable.vue?vue&type=script&lang=js&"
export * from "./InversionsTable.vue?vue&type=script&lang=js&"
import style0 from "./InversionsTable.vue?vue&type=style&index=0&id=a56c328c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56c328c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDataTable,VIcon})
